/**
 * pages/me/myPrework.js — /me хуудасны «Урьдчилсан шалгалт» таб.
 *
 * ЯАГААД ХЭРЭГТЭЙ ВЭ:
 *   АШУА (анхан шатны удирдах ажилтан) ажилтныг ажилд бүртгэсний дараа тэр
 *   ажилтан өөрөө урьдчилсан шалгалтаа бөглөх ёстой. Гэтэл /me хуудсанд
 *   энэ тухай ЯМАР Ч мэдээлэл байгаагүй — ажилтан «намайг ажилд бүртгэсэн
 *   гэсэн, гэхдээ хаана 5А/15А-аа бөглөх вэ?» гэдгээ мэдэхгүй байв.
 *   (Бөглөх хуудсууд нь /highrisk/prework5a, /highrisk/prework15 хаягтай ч
 *    тэр рүү хөтлөх холбоос хаанаас ч байхгүй байсан.)
 *
 * ЖУРМЫН ХАРГАЛЗАА:
 *   Ажлын даалгавар  → 5А дадлын урьдчилсан шалгалт
 *   ӨЭА (өндөр эрсдэлт ажил) → 15 асуумжийн урьдчилсан шалгалт
 *
 * Эх сурвалж: GET /api/mobile/hazard/registertn?mine=1
 *   (xab.oea_worker_registrations — АШУА-гийн бүртгэсэн мөрүүд)
 */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listMyOeaRegistrations } from "src/api/hazard";

const GREEN = "#1B7A45";
const MUTED = "#A8AFBC";

/** Ажлын төрөл → аль чек лист, хаана бөглөх. */
const WORK_TYPE = {
  NARYAD: {
    label: "Ажлын даалгавар",
    checklist: "5А дадлын урьдчилсан шалгалт",
    short: "5А",
    path: "/highrisk/prework5a",
    color: "#1B4C8F",
    icon: "fa-clipboard-list",
    doneField: "checklist_5a_completed",
    atField: "checklist_5a_completed_at",
    scoreField: "checklist_5a_score",
  },
  OEA: {
    label: "Өндөр эрсдэлт ажил",
    checklist: "15 асуумжийн урьдчилсан шалгалт",
    short: "15А",
    path: "/highrisk/prework15",
    color: "#C2410C",
    icon: "fa-exclamation-triangle",
    doneField: "checklist_15_completed",
    atField: "checklist_15_completed_at",
    scoreField: "checklist_15_score",
  },
};
// ⚠ Icon нэрс FA5 (fa-clipboard-list, fa-exclamation-triangle). Төсөлд
//   Font Awesome FREE 5.11.2 суусан тул FA6-ийн нэр (fa-exclamation-triangle)
//   ХАРАГДАХГҮЙ — шинэ icon нэмэхдээ FA5-ын нэрийг ашиглана.

const APPROVAL = {
  PENDING: { name: "Хүлээгдэж буй", bg: "#FEF6E7", fg: "#CA8A04" },
  APPROVED: { name: "Зөвшөөрсөн", bg: "#E7F6EC", fg: "#16A34A" },
  REJECTED: { name: "Татгалзсан", bg: "#FDECEC", fg: "#DC2626" },
};

const fmtDay = (v) => (v ? String(v).slice(0, 10) : "—");

function Chip({ bg, fg, children }) {
  return (
    <span
      style={{
        display: "inline-block",
        padding: "3px 10px",
        borderRadius: 999,
        fontSize: 11,
        fontWeight: 700,
        whiteSpace: "nowrap",
        background: bg,
        color: fg,
      }}
    >
      {children}
    </span>
  );
}

export default function MyPrework() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(() => {
    setLoading(true);
    setError("");
    listMyOeaRegistrations()
      .then((r) => setRows(Array.isArray(r) ? r : []))
      .catch((e) =>
        setError(
          e?.response?.data?.message ||
            "Бүртгэлийг татаж чадсангүй. Дахин оролдоно уу.",
        ),
      )
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  // Шинэ ажил дээр — бөглөөгүй нь ЭХЭНД. Ингэснээр ажилтан юу хийх ёстойгоо
  // жагсаалтын дээд талаас шууд харна.
  const sorted = useMemo(() => {
    const arr = [...rows];
    arr.sort((a, b) => {
      const da = WORK_TYPE[a.work_type]?.doneField;
      const db_ = WORK_TYPE[b.work_type]?.doneField;
      const ad = da ? !!a[da] : true;
      const bd = db_ ? !!b[db_] : true;
      if (ad !== bd) return ad ? 1 : -1; // бөглөөгүй нь дээр
      return String(b.work_date || "").localeCompare(String(a.work_date || ""));
    });
    return arr;
  }, [rows]);

  const pendingCount = useMemo(
    () =>
      sorted.filter((r) => {
        const m = WORK_TYPE[r.work_type];
        return m && !r[m.doneField];
      }).length,
    [sorted],
  );

  if (loading) {
    return (
      <div style={{ padding: 30, textAlign: "center", color: MUTED }}>
        <i className="fas fa-spinner fa-spin" /> Уншиж байна...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 20, color: "#DC2626", fontSize: 13 }}>
        <i className="fas fa-exclamation-circle" style={{ marginRight: 6 }} />
        {error}
      </div>
    );
  }

  if (!sorted.length) {
    return (
      <div style={{ padding: 30, textAlign: "center", color: MUTED, fontSize: 13 }}>
        Танд бүртгэгдсэн ажил алга байна.
        <div style={{ fontSize: 12, marginTop: 6 }}>
          Анхан шатны удирдах ажилтан таныг ажлын даалгавар эсвэл өндөр
          эрсдэлт ажилд бүртгэсний дараа энд гарч ирнэ.
        </div>
      </div>
    );
  }

  return (
    <div>
      {pendingCount > 0 ? (
        <div
          style={{
            margin: "0 0 12px",
            padding: "10px 14px",
            borderRadius: 10,
            background: "#FEF6E7",
            border: "1px solid #F5DFA6",
            color: "#8A6100",
            fontSize: 12.5,
            fontWeight: 600,
          }}
        >
          <i className="fas fa-exclamation-circle" style={{ marginRight: 6 }} />
          Бөглөөгүй {pendingCount} урьдчилсан шалгалт байна. Ажилд гарахын
          өмнө бөглөнө үү.
        </div>
      ) : null}

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#F7F8FA" }}>
              {/* 3 багана. Өмнө нь 6 багана (огноо · төрөл · ажил · шалгалт ·
                  зөвшөөрөл · товч) байсан — утсан дээр хэвтээ гүйлгэдэг,
                  холбоотой мэдээлэл (огноо/төрөл/шалгалт; товч/зөвшөөрөл)
                  тарж байв. Одоо ХОЛБООТОЙ зүйлс нэг нүдэнд, давхарлан. */}
              {["Үйлдэл", "Огноо", "Ажил / чиглэл"].map((h) => (
                <th
                  key={h}
                  style={{
                    textAlign: "left",
                    padding: "10px 14px",
                    fontSize: 11,
                    fontWeight: 700,
                    letterSpacing: 0.4,
                    textTransform: "uppercase",
                    color: "#8A94A6",
                    whiteSpace: "nowrap",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sorted.map((r) => {
              const m = WORK_TYPE[r.work_type];
              const done = m ? !!r[m.doneField] : false;
              const ap = APPROVAL[r.work_approval_status];
              return (
                <tr key={r.id} style={{ borderTop: "1px solid #EDEFF3" }}>
                  {/* ── ҮЙЛДЭЛ — хамгийн эхэнд; доор нь ЗӨВШӨӨРӨЛ ──────────
                      Ажилтны хийх зүйл нь товч тул нүдэнд түрүүлж өртөх ёстой.
                      Зөвшөөрлийн төлөв нь товчтой шууд холбоотой («бөглөх
                      боломжтой юу») тул тэр дор нь. */}
                  <td
                    style={{
                      padding: "10px 14px",
                      verticalAlign: "top",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {m ? (
                      <button
                        type="button"
                        onClick={() => navigate(m.path)}
                        style={{
                          height: 30,
                          padding: "0 14px",
                          borderRadius: 8,
                          border: done
                            ? "1px solid #DDE1E7"
                            : `1px solid ${GREEN}`,
                          background: done ? "#fff" : GREEN,
                          color: done ? "#5A6478" : "#fff",
                          fontSize: 12.5,
                          fontWeight: 700,
                          cursor: "pointer",
                        }}
                      >
                        {done ? "Харах" : `${m.short} бөглөх`}
                      </button>
                    ) : null}
                    <div style={{ marginTop: 6 }}>
                      {ap ? (
                        <Chip bg={ap.bg} fg={ap.fg}>
                          {ap.name}
                        </Chip>
                      ) : (
                        <span style={{ color: MUTED, fontSize: 12 }}>—</span>
                      )}
                    </div>
                  </td>

                  {/* ── ОГНОО; доор нь АЖЛЫН ТӨРӨЛ, дараа нь ШАЛГАЛТ ──────── */}
                  <td
                    style={{
                      padding: "10px 14px",
                      verticalAlign: "top",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div style={{ fontSize: 13, fontWeight: 600 }}>
                      {fmtDay(r.work_date)}
                    </div>
                    <div style={{ marginTop: 4 }}>
                      {m ? (
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            color: m.color,
                            fontWeight: 700,
                            fontSize: 12,
                          }}
                        >
                          <i className={"fas " + m.icon} />
                          {m.label}
                        </span>
                      ) : (
                        <span style={{ color: MUTED, fontSize: 12 }}>
                          {r.work_type || "—"}
                        </span>
                      )}
                    </div>
                    <div style={{ marginTop: 6 }}>
                      {!m ? null : done ? (
                        <div>
                          <Chip bg="#E7F6EC" fg="#16A34A">
                            {m.short} бөглөсөн
                          </Chip>
                          <div style={{ fontSize: 11, color: MUTED, marginTop: 3 }}>
                            {fmtDay(r[m.atField])}
                            {r[m.scoreField] != null
                              ? ` · ${r[m.scoreField]} оноо`
                              : ""}
                          </div>
                        </div>
                      ) : (
                        <Chip bg="#FDECEC" fg="#DC2626">
                          {m.short} бөглөөгүй
                        </Chip>
                      )}
                    </div>
                  </td>

                  {/* ── АЖИЛ / ЧИГЛЭЛ ───────────────────────────────────── */}
                  <td style={{ padding: "10px 14px", verticalAlign: "top" }}>
                    <div style={{ fontSize: 13, color: "#1F2430" }}>
                      {r.work_description || r.destination || "—"}
                    </div>
                    {r.destination && r.work_description ? (
                      <div style={{ fontSize: 11.5, color: MUTED, marginTop: 2 }}>
                        {r.destination}
                      </div>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
